{
  "emptyTitle": "No athlete yet",
  "createAthlete": "Create athlete",
  "rename": "Rename athlete",
  "nameLabel": "Athlete name",
  "editThresholds": "Edit thresholds",
  "thresholdsTitle": "{{sport}} thresholds",
  "thresholds": {
    "ftp": "FTP (W)",
    "lthr": "LTHR ({{unit}})",
    "pace": "Threshold pace ({{unit}})",
    "cssPace": "CSS pace ({{unit}})",
    "maxHeartRate": "Max Heart Rate ({{unit}})",
    "optional": "Optional for running",
    "saved": "Saved",
    "invalid": {
      "whole": "Enter a whole number above 0.",
      "heartRate": "Enter a whole number between 1 and 250.",
      "pace": "Use minutes and seconds, for example 4:30."
    }
  },
  "sportAria": "Sport",
  "zonesTitle": "{{sport}} zones",
  "adjustZones": "Adjust zones",
  "noThreshold": "Set a {{sport}} threshold to see your zones",
  "zonesReason": "Derived from {{metric}} {{value}}. These five bands are what the AI writes workouts against and what your watch receives as targets.",
  "zonesReasonNoThreshold": "These five bands are what the AI writes workouts against and what your watch receives as targets.",
  "metric": {
    "ftp": "FTP",
    "thresholdPace": "Threshold pace",
    "cssPace": "CSS pace",
    "thresholdHr": "Threshold HR",
    "maxHr": "Max HR"
  },
  "provenance": {
    "synced": "{{source}} · {{when}}",
    "manual": "By hand",
    "manualSince": "By hand · {{when}}"
  },
  "reconcile": {
    "title": "{{source}} recorded {{value}} on {{date}}",
    "body": "Kaiord is still using {{current}}, and your zones are derived from that.",
    "use": "Use {{value}}",
    "keep": "Keep {{value}}"
  },
  "autoImport": {
    "title": "Let a connected source update these numbers",
    "hint": "Off means nothing overwrites a number you typed yourself."
  },
  "connections": {
    "title": "Connections",
    "none": "No connections yet",
    "manage": "Manage in Connections"
  },
  "tagline": {
    "cycling": "Cyclist",
    "running": "Runner",
    "swimming": "Swimmer",
    "fallback": "Athlete"
  },
  "defaultProfile": {
    "notice": "We created “{{name}}” so you can start right away. Add your thresholds and weight to get personal zones and estimates.",
    "complete": "Complete details",
    "dismiss": "Got it"
  },
  "title": "Athlete",
  "body": {
    "title": "Body",
    "saved": "Saved",
    "currentWeight": "Current weight ({{unit}})",
    "currentWeightHint": "Saved as today's weigh-in.",
    "height": "Height ({{unit}})",
    "birthDate": "Birth Date",
    "restingHeartRate": "Resting Heart Rate (bpm)",
    "sex": "Sex",
    "activityLevel": "Activity Level",
    "notSet": "Not set",
    "sexes": {
      "male": "Male",
      "female": "Female"
    },
    "activityLevels": {
      "sedentary": "Sedentary",
      "light": "Light",
      "moderate": "Moderate",
      "active": "Active",
      "very_active": "Very active"
    }
  },
  "sports": {
    "cycling": "Cycling",
    "running": "Running",
    "swimming": "Swim"
  },
  "zonesPage": {
    "back": "Athlete",
    "thresholds": "Thresholds: {{list}}",
    "thresholdItem": "{{label}} {{value}}",
    "noThresholds": "No thresholds yet. Zones follow the thresholds you set on the Athlete page."
  },
  "athletes": {
    "title": "Athletes",
    "intro": "Everyone whose training you manage in this browser. Every page shows the active athlete.",
    "name": "Name",
    "newName": "New athlete's name",
    "create": "Create athlete",
    "import": "Import athlete",
    "importFile": "Athlete file",
    "fileHint": "An athlete file holds one athlete: their zones and personal data. To copy everything, use the backup.",
    "backupLink": "Open Data and backup",
    "importFailed": "Import failed: {{message}}",
    "importInvalid": "This file is not a Kaiord athlete file.",
    "importSaveFailed": "Couldn't save the imported athlete. Please try again.",
    "list": "Athletes ({{count}})",
    "active": "Active",
    "setActive": "Make active",
    "setActiveFor": "Make {{name}} active",
    "editDetails": "Body and zones",
    "rename": "Rename {{name}}",
    "save": "Save",
    "cancel": "Cancel",
    "export": "Export {{name}}",
    "delete": "Delete {{name}}",
    "deleteOnly": "The only athlete can't be deleted. Create another one first.",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "This deletes the athlete and everything recorded for them in this browser: workouts, health, nutrition and connections. It can't be undone.",
    "confirmDelete": "Delete athlete",
    "summaryFtp": "FTP {{value}} W",
    "summaryLthr": "LTHR {{value}} bpm",
    "toast": {
      "switchFailed": "Couldn't switch athlete. Please try again.",
      "switched": "Active athlete: {{name}}",
      "createFailed": "Couldn't create the athlete. Please try again.",
      "saveFailed": "Couldn't save the athlete. Please try again.",
      "deleteFailed": "Couldn't delete the athlete. Please try again.",
      "imported": "Athlete imported."
    }
  }
}
